import DesempenhoColaboradores from "@pages/DesempenhoColaboradores/DesempenhoColaboradores";

export default DesempenhoColaboradores;
